<alert type="danger" *ngFor="let msg of messages">
  {{ msg.description }}
</alert>
